import { hasAuthCookie } from '@quintoandar/fwp-cookie';
import { MKT_PHOTOGRAPHER } from 'constants/externalLinks';
import { authorizePhotographerUser } from 'containers/Authorization/actions';
import { authorize } from 'api/authentication';
import { getUser } from 'utils/user';
import { logFailure } from 'utils/log';

const goToLoginPage = ({ redirectToUrl }) =>
  window.location.replace(`${process.env.IDENTITY_WEBAPP_URL}/auth/login?redirect=${redirectToUrl}`);

const isNotPhotographer = ({ authorization }) =>
  authorization && !authorization.allowed;

const goToPhotographersLandingPage = () =>
  window.location.replace(MKT_PHOTOGRAPHER);

const verifyAuthorization = async ({ store }) => {
  const user = getUser();
  let responseData;
  const path = window.location.pathname.split('/')[1];
  const route = path || 'sessao-fotos';

  try {
    responseData = await authorize({ id: user.user_id, route });
  } catch (message) {
    logFailure({ message });
    return;
  }

  store.dispatch(authorizePhotographerUser(responseData));

  if (isNotPhotographer(responseData)) {
    goToPhotographersLandingPage();
  }
};

const verifyAuthenticationAndAuthorization = async (
  store,
  nextState
) => {
  const userPhotographer = store.getState().authorization.userPhotographer;

  if (!hasAuthCookie()) {
    const redirectUrl = `${window.location.origin}${nextState.location.pathname}`;
    goToLoginPage({ redirectToUrl: redirectUrl });
    return;
  }

  if (!userPhotographer.allowed) {
    verifyAuthorization({ store });
    return;
  }

  if (isNotPhotographer({ authorization: userPhotographer.authorization })) {
    goToPhotographersLandingPage();
  }
};

export const onEnterLoggedIn = store => (nextState) => {
  verifyAuthenticationAndAuthorization(store, nextState);
};

export const onChangeLoggedIn = store => (_, nextState) => {
  verifyAuthenticationAndAuthorization(store, nextState);
};
